import { memo, useMemo } from 'react';

import Typography from 'components/UI/Typography/Typography';
import Section from 'components/pages/Analytics/Layout/Section/Section';

import { DISCLAIMER_ITEMS } from 'components/config/analytics';

import styles from './Disclaimer.module.scss';

const Disclaimer = () => {
  const itemsJSX = useMemo(
    () =>
      DISCLAIMER_ITEMS.map(({ title, description }) => (
        <Typography key={title} type="text-xs" color="white">
          <Typography
            type="text-xs"
            element="span"
            weight="semibold"
            color="white"
          >
            {title}{' '}
          </Typography>
          {description}
        </Typography>
      )),
    [],
  );

  return (
    <Section className={styles.section}>
      <div className={styles.wrapper}>
        <Typography weight="semibold" color="white" uppercase>
          LEGAL DISCLAIMER
        </Typography>
        {itemsJSX}
      </div>
    </Section>
  );
};

export default memo(Disclaimer);
